import { render, staticRenderFns } from "./manageSchemaAcquireLimit.vue?vue&type=template&id=05f4ccde"
import script from "./manageSchemaAcquireLimit.vue?vue&type=script&lang=js"
export * from "./manageSchemaAcquireLimit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports